/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Expression({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M12 2h1a1 1 0 0 1 1 1v3.586a1 1 0 0 0 .293.707L15 8l-.707.707a1 1 0 0 0-.293.707V13a1 1 0 0 1-1 1h-1M4 2H3a1 1 0 0 0-1 1v3.586a1 1 0 0 1-.293.707L1 8l.707.707A1 1 0 0 1 2 9.414V13a1 1 0 0 0 1 1h1M5.762 5.553h1.14l2.085 4.893h1.251" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M10.71 5.623c-.948.06-2.024.667-2.985 2.338-.9 1.566-1.67 2.33-2.436 2.417" /></svg>;
}
;